module.exports = __webpack_public_path__ + "img/testing.3b249daa.svg";